export default __webpack_public_path__ + "static/media/sponsor.f73ab94a.png";